export default __webpack_public_path__ + "static/media/redesign-screenshot.0761c615.png";